import React, { createContext, useContext, useEffect, useState } from 'react';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [upgradeMessage, setUpgradeMessage] = useState('');

  const showError = (msg) => setErrorMessage(msg);
  const clearError = () => setErrorMessage('');
  const showSuccess = (msg) => setSuccessMessage(msg);
  const clearSuccess = () => setSuccessMessage('');
  // Friendly paywall nudge (HTTP 402). Distinct from red errors; links to plans.
  const showUpgrade = (msg) => setUpgradeMessage(msg || 'Upgrade to unlock more.');
  const clearUpgrade = () => setUpgradeMessage('');

  // Auto-dismiss banners so a stale message (e.g. the "logged out due to inactivity"
  // notice) doesn't linger after the user acts / logs back in. They stay long enough
  // to read and remain manually dismissible.
  useEffect(() => {
    if (!successMessage) return undefined;
    const t = setTimeout(() => setSuccessMessage(''), 6000);
    return () => clearTimeout(t);
  }, [successMessage]);
  useEffect(() => {
    if (!errorMessage) return undefined;
    const t = setTimeout(() => setErrorMessage(''), 8000);
    return () => clearTimeout(t);
  }, [errorMessage]);
  useEffect(() => {
    if (!upgradeMessage) return undefined;
    const t = setTimeout(() => setUpgradeMessage(''), 8000);
    return () => clearTimeout(t);
  }, [upgradeMessage]);

  return (
    <ErrorContext.Provider value={{ errorMessage, showError, clearError, successMessage, showSuccess, clearSuccess, upgradeMessage, showUpgrade, clearUpgrade }}>
      {children}
      {errorMessage && (
        <div className="alert alert-danger alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3" role="alert" style={{ zIndex: 9999, maxWidth: '600px' }}>
          {errorMessage}
          <button type="button" className="btn-close" onClick={clearError}></button>
        </div>
      )}
      {successMessage && (
        <div className="alert alert-success alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3" role="alert" style={{ zIndex: 9999, maxWidth: '600px' }}>
          {successMessage}
          <button type="button" className="btn-close" onClick={clearSuccess}></button>
        </div>
      )}
      {upgradeMessage && (
        <div className="alert alert-warning alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3" role="alert" style={{ zIndex: 9999, maxWidth: '600px' }}>
          {upgradeMessage}{' '}
          <a href="/" className="alert-link" onClick={clearUpgrade}>See plans →</a>
          <button type="button" className="btn-close" onClick={clearUpgrade}></button>
        </div>
      )}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);
